import axios from "axios";
import { headers, jwt } from "./constants";
import * as yup from "yup";

export interface IBudgetVariable {
  id?: string;
  name?: string;
  category?: string;
}

export const budgetVariableSchema = yup.object().shape({
  name: yup.string().nullable().required("Name is required"),
  category: yup.string().nullable().required("Category is required"),
});

export let list = async () => {
  let hasError = false;
  let response: any = await axios
    .get(process.env.REACT_APP_API_URL + "/budgetVariable/list/", {
      headers: headers,
    })
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { data: response.data, hasError };
};

export let get = async (id: string) => {
  let hasError = false;
  let response: any = await axios
    .get(process.env.REACT_APP_API_URL + "/budgetVariable/get/", {
      headers: headers,
      params: { id: id },
    })
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { data: response.data, hasError };
};

export let create = async (budgetVariable: IBudgetVariable) => {
  let hasError = false;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/budgetVariable/create",
      { data: budgetVariable },
      {
        headers: headers,
      }
    )
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { hasError };
};

export let update = async (budgetVariable: IBudgetVariable) => {
  let hasError = false;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/budgetVariable/update",
      { data: budgetVariable },
      {
        headers: headers,
      }
    )
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { hasError };
};

export let deleteOne = async (budgetVariable: IBudgetVariable) => {
  let hasError = false;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/budgetVariable/delete",
      { data: budgetVariable },
      {
        headers: headers,
      }
    )
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { hasError };
};
